import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import Images from "../../Images"
import { RoutesPaths } from "../../constants/routes"
import { type RootState } from "../../store"
import type { AuthState } from "../LoginPage/redux/auth.type"
import "./styles.less"

interface NotFoundPageProps {
  auth: AuthState
}

function NotFoundPage(props: NotFoundPageProps) {
  const { auth } = props

  return (
    <div className="not-found">
      <img src={Images.logo} alt="" />
      <div className="not-found-content">
        <div>404</div>
        <p>Unfortunately, this page doesn’t exist.</p>
        <p>
          Try{" "}
          <Link
            to={
              !!auth?.accessToken &&
              auth?.userInfo?.onboarding_finished &&
              !auth?.isAdmin
                ? RoutesPaths.home
                : RoutesPaths.auth.login
            }
          >
            start from the mainpage
          </Link>
        </p>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(NotFoundPage)
